import type {Repository} from '@github-ui/current-repository'

/**
 * Resolves the repository nwo for an environment task created from the sidebar
 * composer. The composer owns a fixed repository, but its async repo
 * auto-selection may not have resolved when the user submits, leaving the
 * dispatched `repositoryNwo` absent. Falling back to the owned repository keeps
 * the task associated with it (and its host-correct clone URL) instead of
 * creating a repo-less task that would navigate to `/copilot/tasks/:id`.
 */
export function resolveRepositoryNwo(
  repositoryNwo: string | undefined,
  repository: Pick<Repository, 'nameWithOwner' | 'ownerLogin' | 'name'>,
): string {
  return repositoryNwo ?? repository.nameWithOwner ?? `${repository.ownerLogin}/${repository.name}`
}
